import React from 'react';

export default function Sms() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_6180)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.14925 9.46821C6.47993 10.4618 15.3553 25.6186 15.3553 25.6186C15.7622 26.1272 16.5357 26.1271 16.9426 25.6186L21.3869 17.7616H16.2283L15.1569 19.8251L9.79994 10.3809H25.5932L25.9988 9.78441C26.4066 9.18455 26.2203 8.36462 25.5932 8H6.86351C6.02914 8.19012 5.81857 8.47464 6.14925 9.46821ZM13.0233 12.2459L15.1265 15.8966H22.4278L24.6103 12.2459H13.0233Z'
        fill='url(#paint1_linear_5201_6180)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_6180'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#00DBC4' />
          <stop offset='1' stop-color='#1E7F75' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_6180'
          x1='5.84381'
          y1='4.30159'
          x2='18.298'
          y2='24.8032'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
